import React from "react";
import TransferTable from "./Transfertable";

const EmailTransfer = ({ rows = [], loadingData = false, error = "" }) => (
    <TransferTable
        rows={rows}
        loadingData={loadingData}
        error={error}
        channel="Emails"
    />
);

export default EmailTransfer;